import {
  doGetQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { SITUACAO_ESPECIAL_DESPACHO_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    SITUACAO_ESPECIAL_DESPACHO_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    SITUACAO_ESPECIAL_DESPACHO_ENDPOINT,
    id
  ]);
}
